import axios, { AxiosResponse } from 'axios'

const BASE = process.env.GATSBY_AUTOBAHNPLAKATE_VOTING_SERVICE_API

const api = axios.create({
  baseURL: BASE,
})

let currentNonce: string | null = null

api.interceptors.request.use((config) => {
  if (currentNonce) {
    config.headers['X-Nonce'] = currentNonce
  }
  return config
})

api.interceptors.response.use((response) => {
  const newNonce = response.headers['x-nonce']
  if (newNonce) {
    currentNonce = newNonce
  }
  return response
})

async function getOptions(): Promise<AxiosResponse<any>> {
  return api.get('/api/apvoting/options')
}

async function getResults(): Promise<AxiosResponse<any>> {
  return api.get('/api/apvoting/results')
}

async function sendVote(token: string): Promise<AxiosResponse<any>> {
  return api.post('/api/apvoting/vote', { token })
}

async function sendMessage(
  message: string,
  token: string
): Promise<AxiosResponse<any>> {
  return api.post('/api/apvoting/message', { message, token })
}

async function sendSubscription(email: string): Promise<AxiosResponse<any>> {
  return api.post('/api/apvoting/subscribe', { email })
}

export { getOptions, getResults, sendVote, sendMessage, sendSubscription }
